import { Container } from "react-grid-system";
import styled from "styled-components";
import { theme } from "../theme";

export const StyledBar = styled(Container)`
	background-color: ${({ bg }) => (bg ? bg : "transparent")};
	padding: 1rem 0;
	margin: ${({ infobar }) => (infobar ? "0 0 1.6rem 0" : "1.6rem 0")};
	font-size: 1.4rem;
	font-weight: 700;
	text-transform: uppercase;
	font-family: ${theme.font.secondary};
`;
